import InformationMassage from './InformationMessage';

export default InformationMassage;

